import { useState } from "react";
import { presalesApi } from "../api/presalesApi";
import { ComboBox } from "../../common/components";
import "../../../V2SideDrawer.css";
import "../../../MasterViewV2.css";

const EMPTY_FORM = {
  contact_name:       "",
  designation:        "",
  email:              "",
  phone:              "",
  company_name:       "",
  company_type:       "",
  location:           "",
  source:             "",
  next_action:        "",
  next_action_date:   "",
  deal_value:         "",
  primary_product_id: "",
  owner_id:           "",
  notes:              "",
  chasing_since:      "",
};

export default function LeadFormDrawer({ users, products, onSave, onClose, showToast }) {
  const [form, setForm] = useState(() => ({
    ...EMPTY_FORM,
    chasing_since: new Date().toISOString().slice(0, 10),
  }));
  const [saving, setSaving] = useState(false);

  function set(key, val) {
    setForm((p) => ({ ...p, [key]: val }));
  }

  async function submit() {
    if (!form.contact_name || !form.company_name || !form.owner_id) {
      showToast?.("Contact name, company, and owner are required", "error");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        ...form,
        deal_value: form.deal_value ? Math.round(parseFloat(form.deal_value) * 100) : 0,
        next_action_date: form.next_action_date || null,
        chasing_since: form.chasing_since || new Date().toISOString().slice(0, 10),
        primary_product_id: form.primary_product_id || null,
      };
      await presalesApi.createLead(payload);
      onSave?.();
      showToast?.("Lead created", "success");
    } catch (err) {
      showToast?.(err.message || "Failed to create lead", "error");
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <div className="v2drw-scrim" onClick={onClose} />
      <div className="v2drw" role="dialog" aria-modal="true">
        <div className="v2drw-head">
          <div className="v2drw-head-main">
            <div className="v2drw-title">New Lead</div>
          </div>
          <button className="v2drw-close" onClick={onClose} aria-label="Close">
            <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        <div className="v2drw-body">
          <div className="ps-lfd-form">
            <div className="ps-lfd-row">
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Contact Name *</label>
                <input className="ps-lfd-input" type="text" value={form.contact_name}
                  placeholder="Full name…" onChange={(e) => set("contact_name", e.target.value)} />
              </div>
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Designation</label>
                <input className="ps-lfd-input" type="text" value={form.designation}
                  placeholder="CEO, CTO…" onChange={(e) => set("designation", e.target.value)} />
              </div>
            </div>

            <div className="ps-lfd-row">
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Email</label>
                <input className="ps-lfd-input" type="text" value={form.email}
                  placeholder="email@company.com" onChange={(e) => set("email", e.target.value)} />
              </div>
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Phone</label>
                <input className="ps-lfd-input" type="text" value={form.phone}
                  placeholder="+91…" onChange={(e) => set("phone", e.target.value)} />
              </div>
            </div>

            <div className="ps-lfd-row">
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Company Name *</label>
                <input className="ps-lfd-input" type="text" value={form.company_name}
                  placeholder="Acme Corp…" onChange={(e) => set("company_name", e.target.value)} />
              </div>
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Company Type</label>
                <input className="ps-lfd-input" type="text" value={form.company_type}
                  placeholder="Broker-Dealer" onChange={(e) => set("company_type", e.target.value)} />
              </div>
            </div>

            <div className="ps-lfd-row">
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Product</label>
                <select className="ps-lfd-select" value={form.primary_product_id}
                  onChange={(e) => set("primary_product_id", e.target.value)}>
                  <option value="">— None —</option>
                  {products.map((p) => (
                    <option
                      key={p.id || p.product_id || p.slug || p.name}
                      value={p.id || p.product_id || ""}
                    >
                      {p.name || p.slug || p.product_name || "Unnamed"}
                    </option>
                  ))}
                </select>
              </div>
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Location</label>
                <input className="ps-lfd-input" type="text" value={form.location}
                  placeholder="Mumbai" onChange={(e) => set("location", e.target.value)} />
              </div>
            </div>

            <div className="ps-lfd-row">
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Owner *</label>
                <ComboBox
                  options={users.map((u) => ({ value: u.id, label: u.display_name || u.user_name }))}
                  value={form.owner_id}
                  onChange={(v) => set("owner_id", v)}
                  placeholder="Search owner…"
                />
              </div>
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Deal Value (₹)</label>
                <input className="ps-lfd-input" type="number" value={form.deal_value}
                  placeholder="0" onChange={(e) => set("deal_value", e.target.value)} />
              </div>
            </div>

            <div className="ps-lfd-row">
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Next Action</label>
                <input className="ps-lfd-input" type="text" value={form.next_action}
                  placeholder="Discovery call…" onChange={(e) => set("next_action", e.target.value)} />
              </div>
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Next Action Date</label>
                <input className="ps-lfd-input" type="date" value={form.next_action_date}
                  onChange={(e) => set("next_action_date", e.target.value)} />
              </div>
            </div>

            <div className="ps-lfd-row">
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Chasing Since</label>
                <input
                  className="ps-lfd-input"
                  type="date"
                  value={form.chasing_since}
                  onChange={(e) => set("chasing_since", e.target.value)}
                />
              </div>
              <div className="ps-lfd-fld">
                <label className="ps-lfd-label">Source</label>
                <input className="ps-lfd-input" type="text" value={form.source}
                  placeholder="Inbound, Event…" onChange={(e) => set("source", e.target.value)} />
              </div>
            </div>

            <div className="ps-lfd-fld">
              <label className="ps-lfd-label">Notes</label>
              <textarea className="ps-lfd-textarea" value={form.notes}
                placeholder="Initial context…" onChange={(e) => set("notes", e.target.value)} />
            </div>
          </div>
        </div>

        <div className="v2drw-foot">
          <div className="v2drw-foot-spacer" />
          <button className="v2drw-btn-cancel" onClick={onClose}>Cancel</button>
          <button className="v2drw-btn-save" disabled={saving} onClick={submit}>
            {saving ? "Creating…" : "Create Lead"}
          </button>
        </div>
      </div>
    </>
  );
}
